// import { getUserProfileQuery } from '@redlink/services';

export const freshCache = async (cache, { data }) => {
  await cache.reset();
  // let {
  //   UserProfile: { currentPage, ...rest },
  // } = cache.readQuery({
  //   query: getUserProfileQuery,
  // });

  // cache.writeQuery({
  //   query: getUserProfileQuery,
  //   data: {
  //     UserProfile: {
  //       ...rest,
  //       currentPage: { ...currentPage, needToSetup: false },
  //     },
  //   },
  // });
};
